import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import {CriaOrcamentoAposTotalizador} from "../../utils/CriaOrcamentoAposTotalizador";
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import { WindowMU } from "app/types/WindowMU";



declare var window:WindowMU

export type DefinirPercentualDescontoInput = {
    identificadorItem: number,
    preservaDesconto: boolean
}

export async function definirPreservaDesconto(input: DefinirPercentualDescontoInput) {

    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirPreservaDesconto(
        store.getState().orcamento.IdentificadorOrcamento,
        input.identificadorItem,
        input.preservaDesconto
    )

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    }


    atualizarEstado()
}
